export const queryKeys = {
  adminOverviewMetrics: ['adminOverviewMetrics'] as const,
  activity: ['activity'] as const,
  companies: ['companies'] as const,
  datasources: ['datasources'] as const,
  dashboard: (id: string) => ['dashboard', id] as const,
  dashboards: ['dashboards'] as const,
  hefestoModels: ['hefestoModels'] as const,
  hefestoModel: (id: string) => ['hefestoModel', id] as const,
  users: ['users'] as const,
};
